import React from 'react'
import { CheckoutRequestsSection } from '~/src/features/account/components/CheckoutRequestsSection'
import { useAccountController } from '~/src/features/account/controllers/useAccountController'

export function AccountPage() {
  const { customer, mode, authMethod, isOtpVerificationStep, otpStep, pendingVerification, submitting, error, checkoutRequests, loadingCheckoutRequests, form, actions } = useAccountController()

  if (customer) {
    return (
      <div className="shop-section narrow">
        <h1>Mi cuenta</h1>
        <span>Nombre: {customer.full_name || customer.email}</span>
        <span>Correo: {customer.email}</span>
        <span>Teléfono: {customer.phone_number}</span>
        <CheckoutRequestsSection
          checkoutRequests={checkoutRequests}
          loading={loadingCheckoutRequests}
        />
      </div>
    )
  }

  function submitLabel(mode, authMethod, otpStep) {
    if (authMethod === 'otp' && isOtpVerificationStep) {
      return mode === 'sign_up' ? 'Verificar y crear cuenta' : 'Verificar e ingresar'
    }

    if (authMethod === 'otp') {
      return 'Enviar código de verificación'
    }

    return mode === 'sign_up' ? 'Crear cuenta' : 'Iniciar sesion'
  }

  return (
    <div className="shop-section narrow">
      <div className="account-switch">
        <button type="button" className={mode === 'sign_up' ? 'active' : ''} onClick={() => actions.handleModeChange('sign_up')}>Crear cuenta</button>
        <button type="button" className={mode === 'sign_in' ? 'active' : ''} onClick={() => actions.handleModeChange('sign_in')}>Iniciar sesión</button>
      </div>
      {/*<div className="account-switch">*/}
      {/*  <button className={authMethod === 'otp' ? 'active' : ''} onClick={() => actions.handleAuthMethodChange('otp')}>Codigo por correo</button>*/}
        {/*<button className={authMethod === 'password' ? 'active' : ''} onClick={() => actions.handleAuthMethodChange('password')}>Password</button>*/}
      {/*</div>*/}
      {error && <p className="shop-error">{error}</p>}
      <form className="shop-form" onSubmit={actions.handleSubmit}>
        {mode === 'sign_up' ? (
          <>
            <input
              className="shop-input"
              placeholder="Nombre"
              value={form.first_name}
              onChange={(event) => actions.handleFieldChange('first_name', event.target.value)}
            />
            <input
              className="shop-input"
              placeholder="Apellidos"
              value={form.last_name}
              onChange={(event) => actions.handleFieldChange('last_name', event.target.value)}
            />
            <input
              className="shop-input"
              placeholder="Telefono"
              inputMode="numeric"
              maxLength={10}
              value={form.phone_number}
              onChange={(event) => actions.handleFieldChange('phone_number', event.target.value)}
            />
          </>
        ) : null}
        <input
          className="shop-input"
          placeholder="Correo"
          inputMode="email"
          autoComplete="email"
          pattern="\A[a-zA-Z0-9.!\#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\z"
          title="Ingresa un correo electrónico válido"
          value={form.email}
          onChange={(event) => actions.handleFieldChange('email', event.target.value)}
        />

        {authMethod === 'password' ? (
          <>
            <input
              className="shop-input"
              placeholder="Password"
              type="password"
              value={form.password}
              onChange={(event) => actions.handleFieldChange('password', event.target.value)}
            />
            {mode === 'sign_up' ? (
              <input
                className="shop-input"
                placeholder="Confirmar password"
                type="password"
                value={form.password_confirmation}
                onChange={(event) => actions.handleFieldChange('password_confirmation', event.target.value)}
              />
            ) : null}
          </>
        ) : null}

        {authMethod === 'otp' && isOtpVerificationStep ? (
          <>
            <p>
              Ingresa el codigo enviado a {pendingVerification?.masked_destination || form.email}
            </p>
            <input
              className="shop-input"
              placeholder="Codigo de verificacion"
              inputMode="numeric"
              maxLength={6}
              value={form.code}
              onChange={(event) => actions.handleFieldChange('code', event.target.value)}
            />
            <button className="shop-link-button" type="button" onClick={actions.handleResendCode}>Reenviar codigo</button>
          </>
        ) : null}

        <button type="submit" disabled={submitting}>
          {submitting ? 'Procesando...' : submitLabel(mode, authMethod, otpStep)}
        </button>
      </form>
    </div>
  )
}
